import { render, staticRenderFns } from "./ProductPreviewComponent.vue?vue&type=template&id=48e34baa&scoped=true"
import script from "./ProductPreviewComponent.vue?vue&type=script&lang=js"
export * from "./ProductPreviewComponent.vue?vue&type=script&lang=js"
import style0 from "./ProductPreviewComponent.vue?vue&type=style&index=0&id=48e34baa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e34baa",
  null
  
)

export default component.exports